/*
  local storage is saved as a JSON object per item
    -> 'item' : { key1: 'value1', key2: 'value2' }
  use addItemToLS to add/update individual keys within the item. 
    -> addItemToLS(item, key1, value3) -> 'item': { key1: 'value3', key2: 'value2' }
    -> addItemToLS(item, key3, value4) -> 'item': { key1: 'value3', key2: 'value2', key3: 'value4' }
*/

export const getItemFromLS = (item, key) => {
  let ls = {}
  if (global.localStorage) {
    try {
      ls = JSON.parse(global.localStorage.getItem(item)) || {}
    } catch (e) {
      console.error('error: cannot read local storage ', item)
    }
    return ls[key]
  }
}

export const addItemToLS = (item, key, value) => {
  if (!global.localStorage) return console.error('error: local storage unavailable ', item)

  let existingItem = {}
  try {
    existingItem = JSON.parse(global.localStorage.getItem(item)) || {}
  } catch (e) {
    console.error('error: cannot read local storage ', item)
  }

  existingItem[key] = value
  try {
    global.localStorage.setItem(item, JSON.stringify(existingItem))
  } catch (e) {
    console.error('error: cannot write to local storage ', item)
  }
}

export const overwriteItemInLS = (item, value) => {
  if (!global.localStorage) return console.error('error: local storage unavailable ', item)
  try {
    global.localStorage.setItem(item, JSON.stringify(value))
  } catch (e) {
    console.error('error: cannot write to local storage ', item)
  }
}

export const LS_ITEMS = {
  theme: 'theme',
  currentWell: 'currentWell',
  databaseOrg: 'databaseOrg',
  databaseDefaultOrg: 'databaseDefaultOrg',

  // pinned filters
  sharedWellListGridFilters: 'sharedWellListGridFilters',
  wellSelectorFilters: 'wellSelectorFilters',

  wellInsightsPage: 'wellInsightsPage',
}
